
import {inject, bindable, DOM} from 'aurelia-framework';
import {DialogController} from 'aurelia-dialog';
import {windowCentered} from '../../../../tools/dom';

@inject(DialogController, DOM.Element)

export class CustomDialog {
  @bindable closeAllowed=true;
  @bindable dialogContainer='';

  controller: DialogController;

  constructor(dialogControl: DialogController, public element: HTMLElement) {
    this.controller = dialogControl;
    this.controller.settings.lock = true;
    this.controller.settings.keyboard = true;
  }
  bind() {
    // @ts-ignore
    this.controller.settings.host = this.dialogContainer;
  }
  attached() {
    this.centerAndAdjust();
  }

  centerAndAdjust() {
    windowCentered(this.element);
    this.adjustContent();
  }
  adjustContent() {
    let headerHeigh;
    let footerHeight;
    let dialogHeight;
    let header = this.element.querySelector('ai-dialog-header');
    let body = this.element.querySelector('ai-dialog-body');
    let footer = this.element.querySelector('ai-dialog-footer');
    headerHeigh = header ? header.getBoundingClientRect().height : 0;
    dialogHeight = this.element.getBoundingClientRect().height;
    footerHeight = footer ? footer.getBoundingClientRect().height : 0;
    if (body) {
      (body as HTMLElement).style.maxHeight = (dialogHeight - headerHeigh - footerHeight) + 'px';
    }
  }
  close() {
    // @ts-ignore
    this.controller.close();
  }
}
